import { gql } from '@apollo/client';

export const CREATE_WORK_ASSIGMENT = gql`
	mutation batchAssignCrewMember(
		$newAssignment: WorkAssignmentCreationInput!
		$overlappingActivityAction: OverlappingActivityAction
		$delayMinutes: Int
	) {
		batchAssignCrewMemberV2(
			input: $newAssignment
			overlappingActivityAction: $overlappingActivityAction
			delayMinutes: $delayMinutes
		) {
			... on WorkAssignmentBatchMutationSuccessResponseV2 {
				workAssignmentSequences {
					sequenceGroupId
					rideId
					crewMember {
						id
						fullName
					}
					fromStation {
						id
						name
					}
					toStation {
						id
						name
					}
					fromTimestamp
					toTimestamp
					activityType
					status
					workAssignments {
						crewMember {
							id
							fullName
						}
						status
						version
						id
						fromStation {
							id
							name
						}
						toStation {
							id
							name
						}
					}
					run {
						name
						id
					}
					job {
						id
						code
						runId
					}
					extraActivities {
						fromTimestamp
						toTimestamp
						id
						version
						status
						fromStation {
							id
							code
						}
						toStation {
							id
							code
						}
						activityType
					}
				}
				adjacentWorkAssignmentsAffected
			}
			... on WorkAssignmentBatchMutationErrorResponse {
				errors {
					toStationId
					fromStationId
					errors
				}
			}
			... on WorkAssignmentOverlappingActivitiesResponse {
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							title
							rideId
							deadheadId
							activityType
							status
							fromStation {
								id
								name
								code
							}
							toStation {
								id
								name
								code
							}
							note
							run {
								id
								name
							}
							job {
								id
								code
							}
						}
						... on CrewMemberAbsenceActivityItem {
							reason {
								id
								name
							}
							note
						}
						... on CrewMemberBreakActivityItem {
							breakType
						}
					}
				}
				minDelayMinutes
				maxDelayMinutes
			}
		}
	}
`;
